import { render, staticRenderFns } from "./OrdersQuotes.vue?vue&type=template&id=5b495998"
import script from "./OrdersQuotes.vue?vue&type=script&lang=js"
export * from "./OrdersQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports